import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertInlinePageComponent from './advertInlinePage.component';

let advertInlinePageModule = angular.module('advertInlinePage', [
  uiRouter
])

.component('advertInlinePage', advertInlinePageComponent)

.name;

export default advertInlinePageModule;
